import { render, staticRenderFns } from "./baserecuperoporestudio.vue?vue&type=template&id=7e4bf67b"
import script from "./baserecuperoporestudio.vue?vue&type=script&lang=js"
export * from "./baserecuperoporestudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports